import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { ElForm, ElMessage, FormRules } from 'element-plus';
import { onMounted, reactive, ref, unref, watch } from 'vue';
import { useUser } from '@/store/user.store';
import { GetCatValidInfoApi } from '@/apis/ct_categorys/category.api';
import { GetAuditUserListApi } from '@/apis/contract/contract.draft.api';

// 添加多语言支持
import { useLocales } from '@/hooks/useLocales';

export default /*#__PURE__*/_defineComponent({
  props: {
	categoryId: { type: String, default: () => '' },
	mainstayId: { type: String, default: () => '' },
},
  setup(__props, { expose }) {

const $props = __props

const { t } = useLocales();

const userStore = useUser();



const schema = ref<any>({
	dept_list: [],
	sure_list: [],
	audit_list: [],
	vice_ceo_list: [],
	ceo_list: [],
	boss_list: [],
});

const userFormRef = ref<InstanceType<typeof ElForm>>(); // El表单

const nodeRuleMaps = new Map();
nodeRuleMaps.set('19902', 'dept_list');
nodeRuleMaps.set('19903', 'sure_list');
nodeRuleMaps.set('19904', 'audit_list');
nodeRuleMaps.set('19909', 'vice_ceo_list');
nodeRuleMaps.set('19910', 'ceo_list');
nodeRuleMaps.set('19911', 'boss_list');

const state = reactive({
	userList: [] as any[],
	rules: {} as FormRules,
	load: false,
	isPreview: false,
	createInfo: '',
});

const load = {
	/* 获取验证配置 */
	getCheckValid: async (categoryId: string, mainstayId: string) => {
		if (categoryId && mainstayId) {
			const res = await GetCatValidInfoApi(categoryId, mainstayId);
			(res.data ?? []).forEach((rule: any) => {
				const ruleKey = nodeRuleMaps.get(rule.node_id);
				const isRequired = ruleKey && rule.is_required == 'Y' ? true : false;
				state.rules[ruleKey] = [{ required: isRequired, message: rule.tips, trigger: ['blur', 'change'] }];
			});
		}
	},
};

watch(
	() => $props.categoryId,
	async (id: string) => {
		if (!state.isPreview) {
			state.load = true;
			await load.getCheckValid(id, $props.mainstayId);
			state.load = false;
		}
	}
);

watch(
	() => $props.mainstayId,
	async (id: string) => {
		if (!state.isPreview) {
			state.load = true;
			await load.getCheckValid($props.categoryId, id);
			state.load = false;
		}
	}
);

const funcs = {
	setCreateInfo: (info: string) => {
		state.createInfo = info;
		state.userList = userStore.getSelectList();
	},
	setAuditUserList: async (contractId: string, isPreview?: boolean) => {
		state.load = true;
		const { succeeded, errors, data } = await GetAuditUserListApi(contractId);
		if (!succeeded) {
			ElMessage.error(`${t('auditUser.message.loadAuditUserListError', '读取审批人员列表数据出错，可能的原因是：')}${errors}`);
		} else {
			const auditList = (data || []).map((user: any) => {
				const ruleKey = nodeRuleMaps.get(user.node_id);
				if (ruleKey) {
					schema.value[ruleKey].push(user.user_id);
				}
			});
		}

		state.isPreview = isPreview ? isPreview : false;
		state.userList = userStore.getSelectList();
		state.load = false;
	},
	getAuditUserList: async () => {
		await unref(userFormRef)?.validate();
		const users = unref(schema);
		const auditUsers: any[] = [
			{ node_id: '19902', node_name: '部门批核', user_list: users.dept_list ?? [] },
			{ node_id: '19903', node_name: '使用人确认', user_list: users.sure_list ?? [] },
			{ node_id: '19904', node_name: '会签', user_list: users.audit_list ?? [] },
			{ node_id: '19909', node_name: '分管高级总监/副总裁', user_list: users.vice_ceo_list ?? [] },
			{ node_id: '19910', node_name: '执行副总裁', user_list: users.ceo_list ?? [] },
			{ node_id: '19911', node_name: '董事长', user_list: users.boss_list ?? [] },
		];
		return auditUsers;
	},
};

expose({ ...funcs });
onMounted(() => {
	state.userList = userStore.getSelectList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_select_v2 = _resolveComponent("el-select-v2")!
  const _component_el_row = _resolveComponent("el-row")!
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(_unref(ElForm), {
    class: "mgt-20",
    ref_key: "userFormRef",
    ref: userFormRef,
    size: "small",
    model: schema.value,
    "label-position": "top",
    rules: _unref(state).rules,
    disabled: _unref(state).isPreview
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('auditUser.form.applicant', '申请人')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _unref(state).createInfo,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).createInfo) = $event)),
                    disabled: true
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('auditUser.form.deptAuditor', '部门批核人'),
                prop: "dept_list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    class: "w100",
                    modelValue: schema.value.dept_list,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schema.value.dept_list) = $event)),
                    options: _unref(state).userList,
                    clearable: "",
                    filterable: "",
                    multiple: "",
                    placeholder: _unref(t)('auditUser.placeholder.selectDeptAuditor', '请选择部门批核人'),
                    "tag-type": "primary"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('auditUser.form.sureConfirm', '使用/需求确认'),
                prop: "sure_list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    class: "w100",
                    modelValue: schema.value.sure_list,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schema.value.sure_list) = $event)),
                    options: _unref(state).userList,
                    clearable: "",
                    filterable: "",
                    multiple: "",
                    placeholder: _unref(t)('auditUser.placeholder.sureConfirm', '使用/需求确认'),
                    "tag-type": "primary"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('auditUser.form.auditMember', '会签人'),
                prop: "audit_list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    class: "w100",
                    modelValue: schema.value.audit_list,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schema.value.audit_list) = $event)),
                    options: _unref(state).userList,
                    clearable: "",
                    filterable: "",
                    multiple: "",
                    placeholder: _unref(t)('auditUser.placeholder.auditMember', '会签人'),
                    "tag-type": "primary"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('auditUser.form.viceCeoAudit', '分管高级总监/副总裁审批'),
                prop: "vice_boss_list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    class: "w100",
                    modelValue: schema.value.vice_ceo_list,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((schema.value.vice_ceo_list) = $event)),
                    options: _unref(state).userList,
                    clearable: "",
                    filterable: "",
                    multiple: "",
                    placeholder: _unref(t)('auditUser.placeholder.viceCeoAudit', '分管高级总监/副总裁审批'),
                    "tag-type": "primary"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('auditUser.form.ceoAudit', '执行副总裁审批'),
                prop: "ceo_list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    class: "w100",
                    modelValue: schema.value.ceo_list,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((schema.value.ceo_list) = $event)),
                    options: _unref(state).userList,
                    clearable: "",
                    filterable: "",
                    multiple: "",
                    placeholder: _unref(t)('auditUser.placeholder.ceoAudit', '执行副总裁审批'),
                    "tag-type": "primary"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                label: _unref(t)('auditUser.form.bossAudit', '董事长审批'),
                prop: "boss_list"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select_v2, {
                    class: "w100",
                    modelValue: schema.value.boss_list,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((schema.value.boss_list) = $event)),
                    options: _unref(state).userList,
                    clearable: "",
                    filterable: "",
                    multiple: "",
                    placeholder: _unref(t)('auditUser.placeholder.bossAudit', '董事长审批'),
                    "tag-type": "primary"
                  }, null, 8, ["modelValue", "options", "placeholder"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules", "disabled"])), [
    [_directive_loading, _unref(state).load]
  ])
}
}

})